import React from "react";
import MessageItem from "./MessageItem";
import TypingIndicator from "./TypingIndicator";

const ChatMessages = ({ messages, currentUserId, openViewer, videoPlayingRef, chatEndRef, currentChatTypingUsers, onDeleteMessage, onEditMessage}) => {
  
  // ✅ FIXED: Reverse messages since backend returns latest first
  const displayMessages = [...messages].reverse();

  // Function to group messages by date and add separators
  const getMessagesWithDateSeparators = () => {
    if (!displayMessages.length) return [];
    
    // ✅ FIX: Don't filter deleted messages - let MessageItem handle display
    // Only filter messages deleted specifically for current user (isDeleteMe)
    const visibleMessages = displayMessages.filter(msg => {
      // Hide messages deleted for me only
      if (msg.isDeleteMe === true) return false;
      
      // Show all other messages (including isDeleteEvery)
      return true;
    });
    
    const result = [];
    let lastDate = null;
    
    visibleMessages.forEach((msg, index) => {
      const messageDate = new Date(msg.createdAt);
      const currentDate = messageDate.toDateString();
      
      if (lastDate === null || currentDate !== lastDate) {
        const formattedDate = messageDate.toLocaleDateString('en-US', {
          day: '2-digit',
          month: 'long'
        });
        
        result.push({
          type: 'dateSeparator',
          date: formattedDate,
          timestamp: msg.createdAt,
          id: `date-${msg.createdAt}`
        });
        
        lastDate = currentDate;
      }
      
      result.push({
        type: 'message',
        data: msg,
        index
      });
    });
    
    return result;
  };

  const messagesWithSeparators = getMessagesWithDateSeparators();

  return (
    <div className="chat-box p-3">
      {messagesWithSeparators.map((item) => {
        if (item.type === 'dateSeparator') {
          return (
            <div
              key={item.id}
              className="date-separator text-center my-3"
              style={{ position: 'relative', zIndex: 1 }}
            >
              <span
                style={{
                  backgroundColor: '#f8f9fa',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '0.8rem',
                  color: '#6c757d',
                  fontWeight: 500
                }}
              >
                {item.date}
              </span>
            </div>
          );
        }

        const msg = item.data;
        const senderId = String(msg?.sender?._id || "");
        const meId = String(currentUserId || "");
        const isCurrentUser = (senderId && meId ? senderId === meId : false) || msg?.type === "send";
        const nextMsg = item.index < displayMessages.length - 1 ? displayMessages[item.index + 1] : null;
        const showAvatar = !nextMsg || nextMsg.sender?._id !== msg.sender?._id;

        return (
          <div
            key={msg._id || item.index}
            data-message-id={msg._id}
            data-message-index={item.index}
            className="message-item"
          >
            <MessageItem
              msg={msg}
              index={item.index}
              isCurrentUser={isCurrentUser}
              showAvatar={showAvatar}
              currentUserId={currentUserId}
              openViewer={openViewer}
              videoPlayingRef={videoPlayingRef}
              onDeleteMessage={onDeleteMessage}
              onEditMessage={onEditMessage}
            />
          </div>
        );
      })}

      {currentChatTypingUsers.length > 0 && (
        <TypingIndicator typingUsers={currentChatTypingUsers} messages={displayMessages} currentUserId={currentUserId} />
      )}

      <div ref={chatEndRef} />

      <style>{`
        @keyframes typing {
          0%, 60%, 100% {
            transform: translateY(0);
            opacity: 0.7;
          }
          30% {
            transform: translateY(-10px);
            opacity: 1;
          }
        }
        
        .message-item {
          margin-bottom: 8px;
        }

        .date-separator {
          position: relative;
        }
        
        .date-separator::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background-color: #dee2e6;
          z-index: -1;
        }
      `}</style>
    </div>
  );
};

export default ChatMessages;